import React, { useEffect } from "react";
import TourDetails from "../pages/TourDetails";

// Hero Image
import pangiHero from "../assets/DharamShala-1.png";

// Gallery Images
import g1 from "../assets/pangi-1.png";
import g2 from "../assets/pangi-2.png";
import g3 from "../assets/pangi-3.png";
import g4 from "../assets/pangi-4.png";
import g5 from "../assets/pangi-5.png";
import g6 from "../assets/pangi-6.png"; 
import g7 from "../assets/pangi-7.png";
import g8 from "../assets/pangi-8.png";

export default function PangiValleyTour() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <TourDetails
      title="Pangi Valley Expedition Tour"
      duration="07 Nights / 08 Days"
      includes="Manali, Udaipur, Miyar Valley, Hillu Twan, Sural Bhatori, Sach Pass, Dalhousie"

      heroImage={pangiHero}

      galleryImages={[g1, g2, g3, g4, g5, g6, g7, g8]}

      tourPlan={{

        inclusions: [
          "07 Nights Accommodation (Hotel / Homestay)",
          "Daily Breakfast & Dinner",
          "Private Vehicle for Entire Tour",
          "All Sightseeing as per Itinerary",
          "Driver Allowance, Toll & Parking",
          "All Applicable Taxes Included"
        ],

        days: [

          {
            title: "Day 01: Chandigarh → Manali (320 km / 9 hrs)",
            points: [
              "Breakfast at hotel",
              "Drive to Manali via Pandoh Dam and Mandi",
              "Scenic drive along Beas River",
              "Arrive and check-in at hotel",
              "Evening at leisure",
              "Overnight stay in Manali"
            ],
          },

          {
            title: "Day 02: Manali → Udaipur (154 km / 5 hrs)",
            points: [
              "Breakfast at hotel",
              "Drive via Solang Valley & Atal Tunnel",
              "Pass through Sissu & Keylong",
              "Witness dramatic landscape change to high mountains",
              "Arrive at Udaipur",
              "Overnight stay at hotel"
            ],
          },

          {
            title: "Day 03: Udaipur → Miyar Valley (74 km / 4 hrs)",
            points: [
              "Breakfast at hotel",
              "Excursion to isolated Miyar Valley",
              "Explore stunning Zanskar landscape views",
              "Visit villages like Tingrit, Urgos & Shukto",
              "Return to Udaipur",
              "Overnight stay at hotel"
            ],
          },

          {
            title: "Day 04: Udaipur → Hillu Twan (Pangi Valley) (84 km / 5 hrs)",
            points: [
              "Breakfast at hotel",
              "Drive towards Pangi Valley",
              "Visit Buddhist villages beyond Saichu",
              "Explore Hillu Twan region",
              "Overnight stay at homestay"
            ],
          },

          {
            title: "Day 05: Hillu Twan → Sural Bhatori (59 km / 4 hrs)",
            points: [
              "Breakfast at homestay",
              "Short hike around Hillu Twan village",
              "Explore Saichu Valley trails",
              "Interact with Pangwal & Bhoti communities",
              "Drive to Sural Bhatori",
              "Traditional dinner & overnight stay"
            ],
          },

          {
            title: "Day 06: Sural Bhatori Exploration",
            points: [
              "Morning trek to Para Lam (Chabbi) Waterfall",
              "Visit Snow Valley in Sural Pangi",
              "Enjoy breathtaking mountain views",
              "Evening village walk",
              "Overnight stay at Sural Bhatori"
            ],
          },

          {
            title: "Day 07: Sural Bhatori → Dalhousie via Sach Pass (200 km / 8 hrs)",
            points: [
              "Early breakfast",
              "Drive via Sach Pass (adventurous mountain pass)",
              "Cross glaciers & rugged terrain",
              "Continue towards Dalhousie",
              "Arrival & hotel check-in",
              "Overnight stay at Dalhousie"
            ],
          },

          {
            title: "Day 08: Dalhousie → Amritsar (198 km / 4.5 hrs)",
            points: [
              "Breakfast at hotel",
              "Checkout and drive to Amritsar",
              "Drop at Airport / Railway Station",
              "Tour Ends with Beautiful Memories"
            ],
          },

        ],
      }}

      exclusions={[
        "Any monument entry fees",
        "Any personal expenses",
        "Any guide charges",
        "Air / Train fare",
        "Heater charges (if applicable)",
        "Porter / Coolie charges",
        "5% GST Extra"
      ]}

      remarks={[
        "This is an adventure tour involving high-altitude travel",
        "Sach Pass crossing depends on weather conditions",
        "Accommodation in remote areas will be basic but comfortable",
        "Confirmation subject to availability",
        "AC will not operate in hilly areas",
        "No refund for road blocks or weather disruptions"
      ]}
    />
  );
}